export default __webpack_public_path__ + "static/media/icon-orientation.a8e567bd.svg";